import React, { useState, useRef, useEffect, useCallback } from "react";
import { useSpring, animated } from "react-spring";
import { Background, ModalContent, CloseModalButton, Form, FormContent, Button, Label } from "../../ModalEditStyle";
import api from "../../../../services/api";
import Swal from "sweetalert2";
import CheckBox from "../../../Checkbox";

export default function ModalEdit({ showModal, setShowModal, data, recarregaTabela }) {
  const modalRef = useRef();
  const [email, setEmail] = useState("");
  const [matricula, setMatricula] = useState("");
  const [limpaData, setLimpaData] = useState(false);
  const animation = useSpring({
    config: {
      duration: 150,
    },
    opacity: showModal ? 1 : 0,
    transform: showModal ? `translateY(0%)` : `translateY(-100%)`,
  });

  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 1000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  const keyPress = useCallback(
    (e) => {
      if (e.key === "Escape" && showModal) setShowModal(!showModal);
    },
    [setShowModal, showModal]
  );

  useEffect(() => {
    document.addEventListener("keydown", keyPress);
    return () => document.removeEventListener("keydown", keyPress);
  }, [keyPress]);

  useEffect(() => {
    if (data) {
      setEmail(data.email || "");
      setMatricula(data.matricula || "");
      setLimpaData(false);
    }
  }, [data]);

  async function handleSubmit(e) {
    e.preventDefault();

    const data = {
      email: email,
      matricula: matricula,
      limpaData: limpaData,
    };

    try {
      const response = await api.put(`/rh/controle-cestas/atualizar-dados`, { data });

      if (response.data.error) {
        return Swal.fire("Atenção!", response.data.error, "warning");
      }

      Toast.fire({
        icon: "success",
        title: "Editado com sucesso!",
      });

      setShowModal(!showModal);

      if (recarregaTabela) {
        recarregaTabela();
      }
    } catch (error) {
      Swal.fire("Atenção!", error.response?.data?.error || "Erro ao atualizar!", "error");
    }
  }

  return (
    <>
      {showModal ? (
        <Background
          ref={modalRef}
          onClick={(e) => {
            if (modalRef.current === e.target) {
              setShowModal(!showModal);
            }
          }}
        >
          <animated.div style={animation}>
            <ModalContent>
              <br />
              <Form onSubmit={handleSubmit}>
                <h3>Editar Email</h3>
                <FormContent>
                  <Label>Email:</Label>
                  <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Digite o email" required />
                  <CheckBox label={"Limpar data do envio de email?"} event={() => setLimpaData(!limpaData)} />
                </FormContent>
                <br />
                <Button type="submit">Atualizar</Button>
              </Form>
              <CloseModalButton
                onClick={() => {
                  setShowModal(!showModal);
                }}
              />
            </ModalContent>
          </animated.div>
        </Background>
      ) : null}
    </>
  );
}
